import React, { useRef } from "react";
import Icon from "@ecologi/assets/icons/share.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import styled from "@emotion/styled";

const AccessibleLink = styled.a`
  text-decoration: none;
`;

const ShareWrapper = styled.div`
  cursor: pointer;
  user-select: none;
  pointer-events: none;
  color: ${({ theme }) => theme.colors.charcoal};
  display: flex;
  gap: 4px;

  &:hover {
    color: ${({ theme }) => theme.colors.charcoalLight};
  }
`;

const Text = styled.p`
  margin-top: -2px;
`;

export const ShareButton = () => {
  const copyRef = useRef<HTMLDivElement>(null);
  return (
    <AccessibleLink
      href="#"
      onClick={(e) => {
        e.preventDefault();
        copyRef.current?.click();
      }}
      title="Copy a link to this tile to your clipboard"
    >
      <CopyToClipboard
        onCopy={() => {
          toast.success("Link copied to clipboard");
        }}
        text={window.location.href}
      >
        <ShareWrapper data-testid="forest-modal-share-link" ref={copyRef}>
          <Icon />
          <Text>Share</Text>
        </ShareWrapper>
      </CopyToClipboard>
    </AccessibleLink>
  );
};
